import React from 'react';
import { Grid, Typography } from '@mui/material';

import { ThresholdField } from '../ruleParamsShortSummaries/AmountThreshold';
import TransactionTypeConfigurationField from '../../../customFields/TransactionTypeConfigurationField';

const AmountThreshold = () => (
  <Grid size={12}>
    <Grid container spacing={3}>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography fontWeight="bold">
          Upper threshold
        </Typography>
        <ThresholdField source="ruleParameters.default" />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography fontWeight="bold">
          Lower threshold
        </Typography>
        <ThresholdField source="ruleParameters.lowerThreshold" />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography fontWeight="bold">
          Transaction types configuration
        </Typography>
        <TransactionTypeConfigurationField
          source="ruleParameters.transactionTypeConfiguration"
        />
      </Grid>
    </Grid>
  </Grid>
);

export default AmountThreshold;
